export const API_URL = 'https://www.impeltechnology.com/rest/api';
export const APP_NAME = 'Syso Formularios';
export const DEFAULT_LANGUAGE = 'es';